<script>
import { mapActions } from 'vuex';
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';

export default {
  name: 'EmployeesFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapActions('planning', ['getEmployeesList']),

    getData() {
      return this.getEmployeesList({ search: this.search }).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
